import { computed, ref } from 'vue'
import { mediaBreakpointsAsNumber } from './helpers'
import { mediaBreakpoints } from '@/constants'

export const windowWidth = ref(window.innerWidth)

function onWidthChange(): void {
  windowWidth.value = window.innerWidth
}

window.addEventListener('resize', onWidthChange)

const type = computed(() => {
  if (windowWidth.value < 550) return 'xs'
  if (windowWidth.value >= 550 && windowWidth.value < 1200) return 'md'
  else return 'lg' // Fires when windowWidth.value >= 1200
})

const width = computed(() => windowWidth.value)

export const maxDialog = ref()

export function biggifyDialog() {
  if (width.value < mediaBreakpointsAsNumber(mediaBreakpoints.md)) return { root: 'p-dialog-maximized' }
  return { root: '' }
}

export { width, type }
